import React from 'react';
import { Link } from 'react-router-dom';
import './FinanceDashboard.css';

function FinanceDashboard() {
  return (
    <div className="finance-dashboard">
      <h1>Financial Management</h1>
      <p>Manage your company's financial transactions, payments, and reports.</p>

      <div className="finance-cards">
        <Link to="/finance/account-heads" className="finance-card">
          <div className="card-icon">📋</div>
          <h3>Account Heads</h3>
          <p>Manage income, expense, and payment account categories</p>
        </Link>

        <Link to="/finance/transactions" className="finance-card">
          <div className="card-icon">💳</div>
          <h3>Transactions</h3>
          <p>View all financial transactions in one place</p>
        </Link>

        <Link to="/finance/customer-payments" className="finance-card">
          <div className="card-icon">💵</div>
          <h3>Customer Payments</h3>
          <p>Record customer receipts and payments</p>
        </Link>

        <Link to="/finance/vendor-purchases" className="finance-card">
          <div className="card-icon">🛒</div>
          <h3>Vendor Purchases</h3>
          <p>Record vendor bills and purchases</p>
        </Link>

        <Link to="/finance/vendor-payments" className="finance-card">
          <div className="card-icon">💸</div>
          <h3>Vendor Payments</h3>
          <p>Record payments made to vendors</p>
        </Link>

        <Link to="/finance/reports" className="finance-card">
          <div className="card-icon">📊</div>
          <h3>Financial Reports</h3>
          <p>View cashbook, ledgers, and outstanding reports</p>
        </Link>

        <Link to="/finance/cash-bank" className="finance-card">
          <div className="card-icon">🏦</div>
          <h3>Cash &amp; Bank</h3>
          <p>View balances across cash and bank accounts</p>
        </Link>

        <Link to="/finance/cash-advance" className="finance-card">
          <div className="card-icon">💵</div>
          <h3>Cash Advances</h3>
          <p>Give cash to supervisors and track settlements</p>
        </Link>
      </div>
    </div>
  );
}

export default FinanceDashboard;
